<script lang="ts">
  import { fade } from "svelte/transition";
  import { isCartActive } from "../stores/cart";
</script>

{#if $isCartActive}
  <div transition:fade class="fixed inset-0 z-40 bg-black/50" />
{/if}
